import { Typography } from '@mui/material';
import { IComponentCss } from '@tap/mui-ui';
import { StatusStyleCode, StatusStyleDict, StatusChipVariant } from './status.types';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

/**
 * Статус (вариант: чип)
 */

type StatusChipProps = {
    /** 
     * Название статуса 
     */
    statusName?: string | null,
    /** 
     * Стиль статуса
     */
    styleCode: StatusStyleCode | undefined,

    /** 
     * Вариант отрисовки статуса (contained | outlined | text | withIcon). 
     * По умолчанию contained 
     */
    variant?: StatusChipVariant,
}


const css: IComponentCss = {
    contained: {
        borderRadius: '4px',
        border: '1px solid',
        padding: '0px 4px',
    },
    outlined: {
        borderRadius: '4px',
        border: '1px solid',
        padding: '0px 4px',
    },
    text: {
        padding: '0px',
    },
    withIcon: {
        '> svg': {
            fontSize: 14,
            marginBottom: '-2px',
            marginRight: '5px',
        },
    },
}

const getTextColor = (styleCode: StatusStyleCode, variant: StatusChipVariant) => {
    const statusStyleProps = StatusStyleDict[styleCode] || {};
    switch (variant) {
        case StatusChipVariant.Contained:
            return statusStyleProps.invertColor;
        case StatusChipVariant.Outlined:
            return statusStyleProps.outlidedTextColor || statusStyleProps.baseColor;
        case StatusChipVariant.WithIcon:
            return undefined;
        case StatusChipVariant.Text:
            return statusStyleProps.textColor || statusStyleProps.baseColor;
    }
}

const getBackgroundColor = (styleCode: StatusStyleCode, variant: StatusChipVariant) => {
    const statusStyleProps = StatusStyleDict[styleCode] || {};
    switch (variant) {
        case StatusChipVariant.Contained:
            return statusStyleProps.backgroundColor || statusStyleProps.baseColor;
        case StatusChipVariant.Outlined:
        case StatusChipVariant.WithIcon:
        case StatusChipVariant.Text:
            return undefined;
    }
}

const getBorderColor = (styleCode: StatusStyleCode, variant: StatusChipVariant) => {
    const statusStyleProps = StatusStyleDict[styleCode] || {};
    switch (variant) {
        case StatusChipVariant.Contained:
            return statusStyleProps.backgroundColor || statusStyleProps.baseColor;
        case StatusChipVariant.Outlined:
            return statusStyleProps.outlinedColor || statusStyleProps.baseColor;
        case StatusChipVariant.WithIcon:
        case StatusChipVariant.Text:
            undefined;
    }
}


export const StatusChip = ({
    statusName,
    styleCode = StatusStyleCode.Unknown,
    variant = StatusChipVariant.Contained,
}: StatusChipProps) => {
    const statusStyleProps = StatusStyleDict[styleCode] || {};
    return (
        <Typography
            component='span'
            sx={{
                ...css[variant],
                color: getTextColor(styleCode, variant),
                backgroundColor: getBackgroundColor(styleCode, variant),
                borderColor: getBorderColor(styleCode, variant),
            }}
        >
            {(variant === StatusChipVariant.WithIcon) &&
                <FiberManualRecordIcon sx={{ color: statusStyleProps.circleColor || statusStyleProps.baseColor }} />
            }
            {!!statusName && (
                <>{statusName}</>
            )}
        </Typography>
    )
}
